import Vue from 'vue';
import Vuetify from 'vuetify';
import fi from 'vuetify/lib/locale/fi';
import sv from 'vuetify/lib/locale/sv';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales: { fi, sv },
    current: 'fi',
  },
  theme: {
    options: {
      customProperties: true,
      variations: true,
    },
    dark: false,
    themes: {
      light: {
        primary: '#005F58',
        secondary: '#D0E8DB',
        accent: '#000000',
        error: '#BF1F4F',
        warning: '#ff9800',
        info: '#274c94',
        success: '#66bb6a',
        koulu: '#246BB3',
        koululight: '#CCE6FF',
        paivakoti: '#E34346',
        paivakotilight: '#FCDDDC',
        kulttuuri: '#484A97',
        kulttuurilight: '#D9DEF0'
      },
      dark: {
        primary: '#005F58',
        secondary: '#D0E8DB',
        accent: '#000000',
        error: '#BF1F4F',
        warning: '#ff9800',
        info: '#274c94',
        success: '#66bb6a',
        koulu: '#246BB3',
        koululight: '#CCE6FF',
        paivakoti: '#E34346',
        paivakotilight: '#FCDDDC',
        kulttuuri: '#484A97',
        kulttuurilight: '#D9DEF0'
      },
    },
  },
});
